import { createContext } from 'react';

import { CustomerPageStep, type ICustomersContext } from 'src/pages/CustomersPage/CustomersPage.context.types';

export const CustomersContext = createContext<ICustomersContext>({
  isEditing: false,

  isMobileGuideOpened: false,

  isLastCustomerStep: false,

  customerStep: CustomerPageStep.Start,
  customerStepsInfo: [],

  customerLeadProduct: null,
  customerLeadProductSpecification: null,

  customerStepGuideKey: null,

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  onEditing: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  toggleMobileGuideOpened: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  goNextStep: () => {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  goBack: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  setLastCustomerStep: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  setCustomerStep: () => {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  setCustomerStepGuideKey: () => {},

  // biome-ignore lint/suspicious/noEmptyBlockStatements: false
  updateCustomerLeadProduct: () => {},
});
